import styled from 'styled-components'

export const OverlayWrapper = styled.div`
    position: fixed;
    overflow: auto;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: #00000038;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: flex-start;

    body {
        overflow: hidden;
    }
`
